import {FeatureDialogComponent} from '../feature-dialog/feature-dialog.component';
import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {FeatureEx} from "../../../../models/features/features";
import {tassign} from "../../../../common/utils";
import {FeatureFilterState} from "../../../../models/features/feature_const";
import {isNullOrUndefined} from "util";
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {MatMenuTrigger} from '@angular/material/menu';


@Component({
  selector: 'edsng-feature-item',
  templateUrl: './feature-item.component.html',
  styleUrls: ['./feature-item.component.css']
})
export class FeatureItemComponent {
  @ViewChild('featureTrigger', {static: true}) singleFeatureTrigger: MatMenuTrigger;
  @Input() feature: FeatureEx;
  @Input() index: number;
  @Output() featureChange: EventEmitter<FeatureEx> = new EventEmitter<FeatureEx>();
  public filterState = FeatureFilterState;

  constructor(public dialog: MatDialog) {
  }

  filterFeature(val: FeatureFilterState, event) {
    this.prevent(event);
    const featEx: FeatureEx = tassign(this.feature, {stateFilter: val});
    this.featureChange.emit(featEx);
  }

  getFeatureStateIcon(): string {
    if (!isNullOrUndefined(this.feature)) {
      return this.feature.stateFilter === FeatureFilterState.YES ? 'included' : (this.feature.stateFilter === FeatureFilterState.NO ? 'excluded' : 'noFilter');
    }
    return 'noFilter';
  }

  prevent(event: any) {
    event.stopPropagation();
  }

  /**
   * Per visualizzare gli stati della feature in mobile
   */
  selectDropDown(feature, event?) {
    this.prevent(event);
    if (window.innerWidth + 16 <= 680) {
      const config = new MatDialogConfig();
      config.position = {
          bottom: "0px",
        };
      config.minWidth = "100%"; // to fill the mobile
      const dialogRef = this.dialog.open(FeatureDialogComponent, config);
      dialogRef.componentInstance.feature = this.feature;
    } else {
      const featureMenu = document.getElementsByClassName('featuresMenuOpened')[0];
      const singleFeatureMenu = document.querySelectorAll('.filterItemOpened.mat-menu-panel');

      if (featureMenu !== undefined && singleFeatureMenu.length === 0) {
        this.singleFeatureTrigger.openMenu();
      }
    }


  }

}
